import { Color, Flex, Text } from "src/elements";
import { useTranslation } from "src/i18n";
import { useCdtCategoryStoresQuery } from "src/pages/CDTTreeEditor/store/useCdtCategoryStoresQuery";

interface Props {
  categoryId: number;
  storeCode: string;
}

/**
 * The CDT version a store resolves to in its category (pinned or via the
 * primary). The store planogram does not record the version it was built
 * with, so this reads the category's current assignments; one query per
 * category serves every row.
 */
export const StoreCdtVersionCell = ({ categoryId, storeCode }: Props) => {
  const { t } = useTranslation("common");
  const storesQuery = useCdtCategoryStoresQuery(categoryId);
  const store = storesQuery.data?.find((candidate) => candidate.storeCode === storeCode);

  if (!store || store.effectiveTreeId === null) {
    return (
      <Text variant="small2" color={Color.textSecondary}>
        {t("storePogsCdtVersion.unknown")}
      </Text>
    );
  }

  return (
    <Flex column align="center" gap="2px">
      <Text variant="small2" whiteSpace="nowrap">
        #{store.effectiveTreeId} {store.effectiveTreeName ?? ""}
      </Text>
      <Text variant="small3" color={Color.textSecondary}>
        {t(store.isDefaultFallback ? "storePogsCdtVersion.primary" : "storePogsCdtVersion.pinned")}
      </Text>
    </Flex>
  );
};
